import { useEffect, useState } from "react";

// Un <img> o un WebSocket no pueden mandar la sesión, así que las URLs de video llevan ?vt=
// con un token firmado por el backend para la cuenta (GET /api/video-token). Si el backend no
// tiene VIDEO_TOKEN_SECRET devuelve token null y las URLs quedan como antes.

const RENOVAR_ANTES_MS = 5 * 60 * 1000;
let guardado = { clave: "", token: null, vence: 0 };
const pendientes = new Map();

export const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVideoToken = (apiBase, email) => {
  const clave = `${apiBase}|${email}`;
  if (guardado.clave === clave && Date.now() < guardado.vence) return Promise.resolve(guardado.token);
  if (!pendientes.has(clave)) {
    // Sin fetch o sin red queda null: el video se pide sin token, como en la transición.
    const pedido = Promise.resolve()
      .then(() => fetch(`${apiBase}/api/video-token?email=${encodeURIComponent(email)}`, { headers: authHeaders() }))
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
      .then((data) => {
        const vigencia = Math.max(60 * 1000, (data?.expires_in || 0) * 1000 - RENOVAR_ANTES_MS);
        guardado = { clave, token: data?.token || null, vence: Date.now() + vigencia };
        return guardado.token;
      })
      .finally(() => pendientes.delete(clave));
    pendientes.set(clave, pedido);
  }
  return pendientes.get(clave);
};

export const addVideoToken = (url, token) =>
  token && url ? `${url}${url.includes("?") ? "&" : "?"}vt=${encodeURIComponent(token)}` : url;

// undefined mientras se pide el primero; después el token, o null si el backend no da tokens.
export const useVideoToken = (apiBase, email) => {
  const clave = `${apiBase}|${email}`;
  const [token, setToken] = useState(guardado.clave === clave && Date.now() < guardado.vence ? guardado.token : undefined);
  useEffect(() => {
    if (!email) { setToken(null); return undefined; }
    let vigente = true;
    let timer;
    // Se vuelve a pedir cuando vence el guardado (5 min antes que el token), no a intervalos fijos.
    const pedir = () => getVideoToken(apiBase, email).then((t) => {
      if (!vigente) return;
      setToken(t);
      timer = setTimeout(pedir, Math.max(60 * 1000, guardado.vence - Date.now()));
    });
    pedir();
    return () => { vigente = false; clearTimeout(timer); };
  }, [apiBase, email]);
  return token;
};
